import { render, staticRenderFns } from "./studentExamLayout.vue?vue&type=template&id=f80b9f2a&scoped=true&"
import script from "./studentExamLayout.vue?vue&type=script&lang=js&"
export * from "./studentExamLayout.vue?vue&type=script&lang=js&"
import style0 from "./studentExamLayout.vue?vue&type=style&index=0&id=f80b9f2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80b9f2a",
  null
  
)

export default component.exports